let hidden, visibilityChange;

if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
  hidden = "msHidden";
  visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}

const loadScript = async (src, onLoadCallback = () => {}) => {
  let tag = document.createElement('script');
  tag.async = false;
  tag.src = src;
  tag.onload = onLoadCallback;
  const body = document.getElementsByTagName('body')[0];
  body.appendChild(tag);
};

export { hidden, visibilityChange, loadScript }
